import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";

const Circle = ({ colors, isMoving, disableRandomDelay }) => {
  const controls = useAnimation();

  useEffect(() => {
    let timeoutId;
    let isMounted = true;

    let delay = disableRandomDelay ? 4000 : Math.random() * 3000 + 4000;

    const startLightCycle = () => {
      if (!isMounted) return; // prevent calling after unmount
      const backgroundColor = colors.active
        ? [colors.default, colors.active, colors.default]
        : [colors.default];

      controls.start({
        backgroundColor,
        x: isMoving ? isMoving : 0,
        transition: { duration: 3, ease: "easeInOut" },
      });
      timeoutId = setTimeout(startLightCycle, delay);
    };

    timeoutId = setTimeout(startLightCycle, delay);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId); // cleanup timeout on unmount
    };
  }, [controls, colors, isMoving, disableRandomDelay]);

  return (
    <motion.div
      className="rounded-full"
      style={{ width: 65, height: 65, backgroundColor: colors.default }}
      animate={controls}
    />
  );
};

export default Circle;
